import React, { useEffect, useMemo, useState } from "react";
import "./Download.css";
import Footer from "../components/Footer";
import { fetchAndCachePublicData, getCachedPublicData } from "../utils/publicDataCache";

const API = "";
const DOWNLOAD_CACHE_KEY = "public-download-sections";

function Download() {
  const [sections, setSections] = useState([]);
  const [activeSectionId, setActiveSectionId] = useState(null);

  useEffect(() => {
    let active = true;

    const loadDownloads = async () => {
      const cached = getCachedPublicData(DOWNLOAD_CACHE_KEY);
      if (cached && active) {
        setSections(cached.data);
      }

      try {
        const rows = await fetchAndCachePublicData(DOWNLOAD_CACHE_KEY, "/download-sections");
        if (!active) return;
        setSections(rows);
      } catch {
        if (!active || cached) return;
        setSections([]);
      }
    };

    loadDownloads();

    return () => {
      active = false;
    };
  }, []);

  const activeSection = useMemo(
    () => sections.find((item) => item.id === activeSectionId) || null,
    [activeSectionId, sections]
  );

  return (
    <>
      <div className="download-page">
        <div className="download-shell container py-5">
          <div className="download-hero">
            <span className="download-kicker">Files & Resources</span>
            <h1>Download Center</h1>
          </div>

          {!activeSection ? (
            <>
              <div className="download-section-list">
                {sections.map((section) => (
                  <button key={section.id} type="button" className="download-section-card" onClick={() => setActiveSectionId(section.id)}>
                    <div className="download-section-thumb">
                      <img src={`${API}/uploads/${section.thumbnail}`} alt={section.title} />
                    </div>
                    <div className="download-section-copy">
                      <h3>{section.title}</h3>
                    </div>
                  </button>
                ))}
              </div>

              {!sections.length ? <div className="download-empty">No download section available right now.</div> : null}
            </>
          ) : (
            <div className="download-panel">
              <div className="download-panel-heading">
                <div>
                  <h2>{activeSection.title}</h2>
                  <p>{activeSection.description || "No description available for this section yet."}</p>
                </div>
                <div className="download-panel-actions">
                  <div className="download-count">{activeSection.items?.length || 0} files</div>
                  <button type="button" className="download-back-button" onClick={() => setActiveSectionId(null)}>
                    Back To Download List
                  </button>
                </div>
              </div>

              <div className="download-grid">
                {(activeSection.items || []).map((item) => (
                  <div key={item.id} className="download-item-card">
                    <img
                      src={item.thumbnail ? `${API}/uploads/${item.thumbnail}` : "https://placehold.co/900x600/e2e8f0/475569?text=File"}
                      alt={item.title}
                    />
                    <div className="download-item-body">
                      <h3>{item.title}</h3>
                      <p>{item.description || "No description added for this file yet."}</p>
                      <span className="download-file-name">{item.file_name || "Download file"}</span>
                      <a href={`${API}/uploads/${item.file_path}`} className="download-action-button d-inline-flex justify-content-center text-decoration-none" download>
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {!activeSection.items?.length ? <div className="download-empty mt-4">No file available in this section yet.</div> : null}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Download;
